export const JWT_NS = 'https://cignaforhcp.cigna.com';
